const data = [
  {
    type: "quote",
    text: `D&M SERVICES:<br/>Twoja firma księgowo-doradcza w irlandii`,
  },
  {
    type: "paragraph",
    text: `D&M SERVICES to polskie biuro księgowe w Irlandii, które od 2008 roku wspiera przedsiębiorców w prowadzeniu działalności gospodarczej w Dublinie, Cork oraz na terenie całej Irlandii. Od blisko 20 lat pomagamy naszym klientom bezpiecznie rozwijać biznes, dbając o prawidłowe rozliczenia podatkowe, terminowość oraz zgodność z przepisami irlandzkiego urzędu skarbowego Revenue.`,
  },
  {
    type: "paragraph",
    text: `Specjalizujemy się w obsłudze:`,
  },
  {
    type: "paragraph",
    text: `<ul class='about-us-bullets'>
      <li>Sole Trader (jednoosobowa działalność gospodarcza w Irlandii)</li>
      <li>Spółek LTD</li>
      <li>Małych i średnich przedsiębiorstw</li>
      <li>Startupów rozpoczynających działalność w Irlandii</li>
      <li>Osób zatrudnionych na etacie, chcących sprawdzić zgodność ulg podatkowych lub uzyskać zwrot nadpłaconego podatku</li>
    </ul>`,
  },
  {
    type: "paragraph",
    text: `Dzięki wieloletniemu doświadczeniu doskonale znamy irlandzki system podatkowy, obowiązki przedsiębiorców oraz realia prowadzenia firmy na lokalnym rynku.`,
  },
  {
    type: "quote",
    text: `Nowoczesna księgowość w Irlandii`,
  },
  {
    type: "paragraph",
    text: `Łączymy tradycyjne wartości biura rachunkowego z nowoczesnymi rozwiązaniami online. Oferujemy możliwość elektronicznej wymiany dokumentów, co pozwala naszym klientom oszczędzać czas i wygodnie zarządzać księgowością z dowolnego miejsca w Irlandii.`,
  },
  {
    type: "paragraph",
    text: `Stawiamy na:`,
  },
  {
    type: "paragraph",
    text: `<ul class='about-us-bullets'>
      <li>Przejrzystą komunikację</li>
      <li>Indywidualne podejście do klienta</li>
      <li>Bezpieczeństwo danych</li>
      <li>Terminowość i rzetelność</li>
    </ul>`,
  },
  {
    type: "quote",
    text: `Dlaczego warto nam zaufać?`,
  },
  {
    type: "paragraph",
    text: `<ul class='about-us-bullets'>
      <li>Ponad 15 lat doświadczenia na rynku irlandzkim</li>
      <li>Setki obsłużonych firm</li>
      <li>Obsługę w języku polskim</li>
      <li>Profesjonalne doradztwo księgowe i podatkowe</li>
      <li>Wsparcie na każdym etapie prowadzenia firmy</li>
    </ul>`,
  },
  {
    type: "paragraph",
    text: `W D&M Services wierzymy, że dobra księgowość to nie tylko liczby, ale przede wszystkim partnerstwo i realne wsparcie w rozwoju biznesu. Jeśli szukasz sprawdzonego polskiego księgowego w Irlandii – w Dublinie lub Cork – zapraszamy do kontaktu.`,
  },
  {
    type: "paragraph",
    text: `Oferujemy usługi kompleksowej księgowości, takie jak:`,
  },
  {
    type: "paragraph",
    text: `<ul class='about-us-bullets'>
      <li>Rozliczanie VAT</li>
      <li>Rozliczanie podatku dochodowego</li>
      <li>Rejestrację działalności</li>
      <li>Tworzenie biznesplanów</li>
      <li>Porady biznesowe</li>
      <li>Prowadzenie payroll</li>
      <li>Rozliczenia roczne z tytułu zatrudnienia</li>
    </ul>`,
  },
  {
    type: "paragraph",
    text: `Naszą ofertę kierujemy zarówno do małych, jak i średnich przedsiębiorstw.`,
  },
  {
    type: "quote",
    text: `Biuro Księgowe D&M Accountancy Services to prawie 20 lat doświadczenia i setki zadowolonych klientów.`,
  },
]

export default data
